import { useNavigate, useParams } from "react-router-dom";

export function useLangNavigate() {
  const navigate = useNavigate();
  const { lang } = useParams();

  return (to, options) => {
    if (typeof to === "string") {
      const path = `/${lang}${to.startsWith("/") ? to : "/" + to}`;
      navigate(path, options);
    } else {
      navigate(to, options);
    }
  };
}
